import React from 'react';
import styles from './CatalogDropdown.module.css';

interface CatalogDropdownProps {
  options: string[] | { label: string; value: string }[];
  value: string;
  onChange: (value: string) => void;
}

export const CatalogDropdown: React.FC<CatalogDropdownProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <div className={styles.wrapper}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={styles.select}
      >
        {options.map((opt) => {
          const optValue = typeof opt === 'string' ? opt : opt.value;
          const optLabel = typeof opt === 'string' ? opt : opt.label;
          return (
            <option key={optValue} value={optValue}>
              {optLabel}
            </option>
          );
        })}
      </select>
      <svg viewBox="0 0 24 24" fill="currentColor" className={styles.chevron}>
        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
      </svg>
    </div>
  );
};
